import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DeliveryCompany } from "../../entity/DeliveryCompany";

interface DeliveryState {
  deliveryCompanies: DeliveryCompany | null;
  listDeliveryCompanies: DeliveryCompany[] | null;
}

const initialState: DeliveryState = {
  deliveryCompanies: null,
  listDeliveryCompanies: null,
};

const storeSlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    setDeliveryCompany: (
      state,
      action: PayloadAction<DeliveryCompany | null>,
    ) => {
      state.deliveryCompanies = action.payload;
    },
    setDeliveryCompanies: (
      state,
      action: PayloadAction<DeliveryCompany[] | null>,
    ) => {
      state.listDeliveryCompanies = action.payload;
    },
  },
});

export const { setDeliveryCompany, setDeliveryCompanies } = storeSlice.actions;
export default storeSlice.reducer;
